import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { APPROVAL_MESSAGE, REQUEST_TYPES_ID as RequestType, WIRELINE_REQUEST_TYPES_ID as WirelineRequestIds } from "../../../../constants/external-constants";
import { valueExist } from '../../../../utils/helpers.utils';
import { RequestProcess } from "./request-process.component";
import { RequestDetailProcess } from "./request-detail-process.component";
import RequestCommentSection from "./request-comment-section.component";
import { ListTab } from "../../../common/list-tab/list-tab.component";
import { NewMobileSubscriptionDetails } from "../request-details/request-detail-display-types/wireless/new-mobile-subscription-details.component";
import { ChangeUserDetails } from "../request-details/request-detail-display-types/wireless/change-user-details.component";
import { ChangePricePlanDetails } from "../request-details/request-detail-display-types/wireless/change-price-plan.component";
import { ChangeVendorDetails } from "../request-details/request-detail-display-types/wireless/change-vendor-details.component";
import { ReplaceSimDetails } from "../request-details/request-detail-display-types/wireless/replace-sim-details.component";
import { ReplaceDeviceDetails } from "../request-details/request-detail-display-types/wireless/replace-device-details.component";
import { AccessoryDetails } from "../request-details/request-detail-display-types/wireless/accessory-details.component";
import { TerminateSubscriptionDetails } from "../request-details/request-detail-display-types/wireless/terminate-subscription-details.component";
import IntlRoamingAccessDetails from "../request-details/request-detail-display-types/wireless/intl-roaming-access-details.component";
import { PortOutDetails } from "../request-details/request-detail-display-types/wireless/port-out-details.component";
import PortInDetails from "../request-details/request-detail-display-types/wireless/port-in-details.component";
import { OtherMobileRequestDetails } from "../request-details/request-detail-display-types/wireless/other-mobile-request-details.component";
import { WirelineOtherDetails } from "../request-details/request-detail-display-types/wireline/wireline-other-details.component";

import NewCircuitDetailDisplay from "../request-details/request-detail-display-types/wireline/new-circuit/new-circuit-detail-display.component";
import { OrderQuotationDetails } from "../request-details/request-detail-display-types/order-quotation-details.component";
import { requestDetailsActions } from "../../../../store/external/request-reducer/request-details.reducer";
//wireline components
import { WirelineChangeVendorDetails } from "../request-details/request-detail-display-types/wireline/wireline-change-vendor-details.component";
import { WirelineTerminateCircuitDetails } from "../request-details/request-detail-display-types/wireline/terminate/wireline-terminate-circuit-details.component";
import Translation from "../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import { REQUEST_MODAL_TAB } from '../../../../utils/constant.utils';
import { requestLogActions } from '../../../../store/external/request-reducer/request-log.reducer';
import {createRequestActions} from '../../../../store/external/request-reducer/create-request.reducer';
import { withRouter } from 'react-router-dom';
import { getRequestUserSessionData as getUserData } from '../../../../utils/helpers.utils';
import { REQUEST_STATUS } from "../../../../../app/constants/external-constants";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";

export class RequestOrderDetails extends Component {
    constructor(props) {
        super(props);
    }

    openRequestModal = (id, type) => {
        const { history, setRequestType, updateOrderRequest } = this.props;
        setRequestType(id, type);
        updateOrderRequest(true);
       
        const orderId = this.props.match.params.id;
        setTimeout(() => {
            history.push(`${history.location.pathname}/Update`);
        }, 100);         
    };

    isAllowUpdate = () => {
        const { data } = this.props;
        let userData = getUserData();
        if (data !== null && data !== undefined) {
            let onBehalfId = data.RequestedInBeHalfOf ? data.RequestedInBeHalfOf.EmployeeId.toString() : '';
            let ownerId = data.Order.RequestorId ? data.Order.RequestorId.toString() : '';
            const showUpdateRequestLink = this.props.history.location.pathname.match(/Inventory.*/) === null ? true : false;
            if (showUpdateRequestLink === false) {
                return false;
            }
            if (userData.employeeID === onBehalfId || userData.employeeID === ownerId) {
                if (data.Order.OrderStatusDisplay === REQUEST_STATUS.inProgress || data.Order.OrderStatusDisplay === REQUEST_STATUS.open) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }    

    renderDisplay = (typeId) => {
        const { isOtherRequest, isQuotationRequest, data, status, selectedItem } = this.props;
        let form;
        let isWireline = valueExist(WirelineRequestIds, typeId);
        switch (typeId) {

            case RequestType.newMobile:
            case RequestType.newCircuitOrder:
                form = <NewMobileSubscriptionDetails openRequestModal={this.openRequestModal} status={status} data={data} isWireline={isWireline} />
                break;
            case RequestType.changeUser:
                form = <ChangeUserDetails openRequestModal={this.openRequestModal} status={status} data={data} history={this.props.history} />
                break;
            case RequestType.changePricePlan:
            case RequestType.upgradeSubscriptionWireline:
                form = <ChangePricePlanDetails data={data} isWireline={isWireline}/>
                break;
            case RequestType.changeVendor:
                form = <ChangeVendorDetails openRequestModal={this.openRequestModal} status={status} data={data} isWireline={isWireline} selectedItem={selectedItem} history={this.props.history} />
                break;
            case RequestType.wirelineChangeVendor:
                form = <WirelineChangeVendorDetails data={data} isWireline={isWireline} />
                break;
            case RequestType.deviceReplacement:
                form = <ReplaceDeviceDetails openRequestModal={this.openRequestModal} data={data} isWireline={isWireline} history = {this.props.history} />
                break;
            case RequestType.accessory:
                form = <AccessoryDetails data={data} openRequestModal={this.openRequestModal} isWireline={isWireline} history={this.props.history} />
                break;
            case RequestType.simReplacement:
                form = <ReplaceSimDetails data={data} />
                break;
            case RequestType.subscriptionCancellation:
                form = <TerminateSubscriptionDetails openRequestModal={this.openRequestModal} data={data} status={status} isWireline={isWireline} isAllowUpdate={this.isAllowUpdate} history={this.props.history} />
                break;
            case RequestType.terminateSubscriptionWireline:
                form = <WirelineTerminateCircuitDetails data={data} isWireline={isWireline}/>
                break;
            case RequestType.CallingAccess:
            case RequestType.intlRoamingAccess:
                form = <IntlRoamingAccessDetails openRequestModal={this.openRequestModal} status={status} data={data} isWireline={isWireline} selectedItem={selectedItem} history={this.props.history} />
                break;
            case RequestType.portIn:
                form = <PortInDetails openRequestModal={this.openRequestModal} status={status} data={data} isWireline={isWireline} />
                break;
            case RequestType.portOut:
                form = <PortOutDetails openRequestModal={this.openRequestModal} data={this.props.data} history={this.props.history} />
                break;
            case RequestType.newSubscriptionWireline:
                form = <NewCircuitDetailDisplay data={this.props.data} />
                break;
            case RequestType.wirelineUpgradeCircuit:
            case RequestType.wirelineChangeLocationAddress:
            case RequestType.wirelineOtherOther:
                form = <WirelineOtherDetails data={this.props.data} />
                break;
            default:
                if (isOtherRequest) {
                    form = <OtherMobileRequestDetails openRequestModal={this.openRequestModal} status={status} data={data} isWireline={isWireline} isAllowUpdate={this.isAllowUpdate} />
                } else if (isQuotationRequest) {
                    form = <OrderQuotationDetails data={this.props.data} />
                }
                else {
                    form = <div></div>
                }
        }

        return form;
    };
    
    render() {
        const { isQuotationRequest, data } = this.props;

        return (
            <>               
                {this.renderDisplay(isQuotationRequest ? null : data?.Order?.RequestType?.RequestTypeID)}
            </>
        );
    }
}

export const ConnectedRequestOrderDetails = withRouter( connect(
    state => {
        const {createRequest, requestLog  } = state;
        return {
             ...requestLog
            , createRequest
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestLogActions, createRequestActions, requestDetailsActions),
            dispatch
        )
)(RequestOrderDetails));

class RequestOrderProgress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleTab: REQUEST_MODAL_TAB.RequestProgress,
        };
        this.tabSelected = this.tabSelected.bind(this);
    }
    componentDidMount() {
        this.tabSelected();
    }

    handleDeleteOrderRequestComments = async (orderId) => {
        this.setState({ isLoading: true });
        const { deleteOrderRequestComment, fetchOrderComments } = this.props;
        await deleteOrderRequestComment(orderId, this.props.orderId);
        await fetchOrderComments(this.props.orderId).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    tabSelected(element) {
        var selectedTabIndex = REQUEST_MODAL_TAB.RequestProgress;

        if(element){
            if(element.currentTarget)
            {
                const selectedTab = element.currentTarget.innerText.trim();
                const commentsTab = this.toLocaleLanguage("comments").trim();
                if (commentsTab.includes(selectedTab))
                    selectedTabIndex = REQUEST_MODAL_TAB.Comments;
                else {
                    this.props.fetchRequestProgress(false);
                }
            } else {
                selectedTabIndex = element;
            }
        }

        document.querySelectorAll(".order-progress-container .isSelectedTab").forEach((el) => el.classList.remove("isSelectedTab"));

        document.querySelectorAll(".process-tab .list-tab").forEach((el) => {
            if(el.attributes.getNamedItem("data-index").nodeValue === selectedTabIndex) {
                el.classList.add("isSelectedTab");
            }
        });
        this.setState({
            toggleTab: selectedTabIndex,
        });

        this.tabItem(selectedTabIndex);
    }

    tabItem(toggleTab) {
        const { activities, milestone, comments } = this.props;
    
        switch (toggleTab) {
            case REQUEST_MODAL_TAB.RequestProgress:
                return (
                    <>
                        <RequestProcess data={milestone} />
                        <RequestDetailProcess activities={activities} onCommentClick={this.tabSelected} />
                    </>
                );
            case REQUEST_MODAL_TAB.Comments:
                
                return (
                    <>
                        <RequestCommentSection comments={comments} history={this.props.history} deleteCommentAction={this.handleDeleteOrderRequestComments.bind(this)} />
                    </>
                    );
            default:
                break;
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };
    
    render() {
        const showComment = this.props.history.location.pathname.match(/Inventory.*/) === null ? true : false;
        //"Request Progress", "Comments"\        
        const listItem = [
            {
                listTitle: <Translation translationKey="request_progress" />,
                //href: "/",
            },      
            {
                listTitle: showComment === true ? <Translation translationKey="comments" /> : '', 
                //href: "/",
            },
        ];
        const { showRejectionCommentBox, businessHoursNotice, showConModal, approvalType, handleConfirmationModal } = this.props;
        return (
            <div className="order-request-process">
                 <ConfirmationNotificationModal 
                    show={showConModal} 
                    message={
                        <>
                            {APPROVAL_MESSAGE.ACTION_CONFIRMATION}&nbsp; 
                            
                            <span className={`${approvalType===APPROVAL_MESSAGE.APPROVE ? "font-green" : "font-red"}`}>
                            {approvalType}</span>&nbsp; 
                            
                            {APPROVAL_MESSAGE.TARGET_REQUEST}
                        </>
                    }
                    title={`${approvalType===APPROVAL_MESSAGE.APPROVE ? APPROVAL_MESSAGE.APPROVE_REQUEST : APPROVAL_MESSAGE.REJECT_REQUEST}`}
                    handleModal={handleConfirmationModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal approve-dialog  modal-text-bold'}
                    isDecisionModal={true}
                />
               
                <div className="process-tab">
                    {
                        businessHoursNotice && <p className="notice-label"><Translation translationKey="notice"/> {businessHoursNotice}</p>
                    }
                    <ul className="tab-list-container">
                        {listItem.map((item, id) => (
                            <li data-index={id} key={id} className="list-tab">
                                <span onClick={(e) => this.tabSelected(e)}>{item.listTitle}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="process-list-container">{showRejectionCommentBox ? this.tabItem("1") : this.tabItem(this.state.toggleTab)}</div>
            </div>
        );
    }
}

export default connect(
    state => {
        const {requestDetail, translation  } = state;
        return {
            ...requestDetail
            , ...translation
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestDetailsActions),
            dispatch
        )
)(RequestOrderProgress);

